import { render, staticRenderFns } from "./BgInput.vue?vue&type=template&id=40f8c64c&scoped=true&"
import script from "./BgInput.vue?vue&type=script&lang=js&"
export * from "./BgInput.vue?vue&type=script&lang=js&"
import style0 from "./BgInput.vue?vue&type=style&index=0&id=40f8c64c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8c64c",
  null
  
)

export default component.exports